/* eslint no-param-reassign: 0 */

import _ from 'underscore';
import ImageAdExtensionsRepository from '@bingads-webui-campaign-legacy/adextension-image/service/imageAdExtensionsRepository2';
import AssociationsRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repos/associations';

const baseSchema = window.globalLegacySchema.get('AdExtension');
const schema = window.globalLegacySchema.get('ImageAdExtension');

const standardProperties = [baseSchema.key, 'Scheduling'];
const commonProperties = _.difference(_.keys(baseSchema.properties), standardProperties);
const ownedProperties = _.difference(_.keys(schema.properties), commonProperties);

// Workaround until the schema is updated
if (ownedProperties.indexOf('DisplayText') < 0) {
  ownedProperties.push('DisplayText');
}

if (ownedProperties.indexOf('EligibleLayout') < 0) {
  ownedProperties.push('EligibleLayout');
}

if (ownedProperties.indexOf('SourceType') < 0) {
  ownedProperties.push('SourceType');
}

const extensionFormatter = (data) => {
  return _.map(data, (item) => {
    return _.pick(item, ownedProperties);
  });
};

export class Repository {
  constructor(options) {
    options = _.extend({
      afterChangeComitted: _.noop,
      extensionDataFormatter: extensionFormatter,
      associationsDataFormatter: (data) => {
        return extensionFormatter(_.pluck(data, 'AdExtension'));
      },
    }, options);

    this.extension = new ImageAdExtensionsRepository(options);
    this.association = new AssociationsRepository(options);
  }
}
